import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import Layout from "../../components/layout";
import Link from "../../components/Link";
import resourceData from "../../components/resource-data.json";
import ProductUpdates from "../../components/v2/blog/product-update";
import SubscribeCtaBlog from "../../components/v2/blog/subscribe-cta-blog";
import CallToActionBlogBottom from "../../components/v2/call-to-action-blog-bottom";
import FormCheckbox from "../../components/v2/form-checkbox";
import { MwSmallIcon, NoData } from "../../components/v2/icons";
import ResourcesCenter from "../../components/v2/mw-carousel/resources-center";
import { getAllPodcast, getAllWebinars, getAllWhitepaper, getProductUpdatesPosts } from "../../lib/api";
import nextI18NextConfig from '../../next-i18next.config';
import "../../styles/scss/resources.module.scss";

export default function Resources({ allWhitepaper: { edges }, preview, allProductUpdates, allPodcasts, allWebinars }: any) {

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState(edges);
    const [webinarChecks, setWebinarChecks] = useState(true);
    const [whitepaperChecks, setWhitepaperChecks] = useState(false);
    const [customerChecks, setCustomerChecks] = useState(false);
    const [productUpdateChecks, setProductUpdateChecks] = useState(false);
    const [podcastsChecks, setPodcastsChecks] = useState(false);
    const [eventsCheck, setEventsCheck] = useState(false);
    const [mediaChecks, setMediaChecks] = useState(false);
    const [allChecks, setAllChecks] = useState(false);

    useEffect(() => {
        const filtered = edges.filter(({ node }) =>
            node.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
    }, [searchQuery, edges]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleAllCheckbox = () => {
        setAllChecks(!allChecks)
        setWebinarChecks(!webinarChecks);
        setWhitepaperChecks(!whitepaperChecks);
        setCustomerChecks(!customerChecks);
        setProductUpdateChecks(!productUpdateChecks);
        setPodcastsChecks(!podcastsChecks);
        setEventsCheck(!eventsCheck);
        setMediaChecks(!mediaChecks);
    };

    useEffect(() => {
        let updatedData = [];

        const productUpdates = allProductUpdates?.edges?.map(edge => ({ node: edge.node })) || [];

        const podcasts = allPodcasts?.edges?.map(edge => ({ node: edge.node })) || [];

        const webinars =
            allWebinars?.edges?.map((edge) => {
                const node = edge.node;
                const tagName = node.tags?.edges?.[0]?.node?.name;
                return {
                    node: {
                        ...node,
                        categories: {
                            edges: [
                                {
                                    node: {
                                        name: tagName || "Webinar",
                                        slug: "webinar",
                                    },
                                },
                            ],
                        },
                    },
                };
            }) || [];

        const whitepapers = edges || [];

        const customerStories = resourceData.allCustomerStories || [];
        const events = resourceData.allEvents || [];
        const media = resourceData.allMedia || [];

        if (allChecks) {
            updatedData = [...productUpdates, ...whitepapers, ...customerStories, ...events, ...media, ...podcasts, ...webinars];
        } else {
            if (productUpdateChecks) updatedData.push(...productUpdates);
            if (whitepaperChecks) updatedData.push(...whitepapers);
            if (customerChecks) updatedData.push(...customerStories);
            if (eventsCheck) updatedData.push(...events);
            if (mediaChecks) updatedData.push(...media);
            if (podcastsChecks) updatedData.push(...podcasts);
            if (webinarChecks) updatedData.push(...webinars);
        }

        if (searchQuery.trim()) {
            updatedData = updatedData.filter(({ node }) =>
                node?.title?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setFilteredData(updatedData);

    }, [
        allChecks,
        productUpdateChecks,
        whitepaperChecks,
        customerChecks,                                                                                                                                                                                                                                                                                             
        eventsCheck,
        mediaChecks,
        searchQuery,
        podcastsChecks,
        webinarChecks,
        allProductUpdates?.edges,
        edges,
        resourceData.allCustomerStories,
        resourceData.allEvents,
        resourceData.allMedia,
        allPodcasts?.edges,
        allWebinars?.edges,
    ]);

    const eventCalendar = resourceData.allEvents.slice(0, 3);

    const productUpdates = allProductUpdates.edges;

    const [visibleCount, setVisibleCount] = useState(10);

    const handleViewMore = () => {
        setVisibleCount((prev) => Math.min(prev + 10, filteredData.length));
    };

    return (
        <Layout
            isHomePage={false}
            pageTitle={'Resources | Middleware'}
            ogImage={"/images/resources/resources-page-og.png"}
            metaTitle={'Observability guides, whitepaper and resources'}
            metaDesc={'Read in-depth guides, whitepapers, ebooks and webinars on observability and monitoring from our experts.'}
            uri={'/resources/'}
            metaRobotsNoindex={"noindex"}
            metaRobotsNofollow={"nofollow"}
        >
            <div className={'middle-wrapper site-page resources-page blog-v2'}>
                <section className={'resource-hero mw-datadog'}>
                    <div className={'container'}>
                        <div className={'d-flex'}>
                            <div className={'left-block'}>
                                <h1>Welcome to the <span className={"text-gradient"}> Middleware Library </span></h1>
                                <p>Explore the Middleware library for whitepapers, eBooks, product updates, events, and webinars on observability and monitoring.</p>
                            </div>
                            <div className={'right-block'}>
                                <ResourcesCenter/>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={'main-resources-whitepaper'}>
                    <div className={'container'}>
                        <div className={"d-flex"}>
                            <div className={"left-block"}>
                                <div className={"left-resource"}>
                                    <div className={'section-tag testimonial'}><MwSmallIcon /> All Resources</div>
                                    <h2>Find Exactly What You Need.</h2>
                                    <input
                                        type={"search"}
                                        placeholder={"Search by name or type"}
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />

                                    <div className={"form-checkbox-resources"}>
                                        <FormCheckbox
                                            id="checkbox"
                                            checked={allChecks}
                                            onChange={handleAllCheckbox}
                                            showMinusIcon
                                            label={"Select All"}
                                        />

                                        <FormCheckbox
                                            id="checkbox-webinar"
                                            checked={webinarChecks}
                                            onChange={(checked) => {
                                                setWebinarChecks(checked ?? false);
                                            }}
                                            label="Webinar"
                                        />

                                        <FormCheckbox
                                            id="checkbox1"
                                            checked={whitepaperChecks}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setWhitepaperChecks(checked ?? false);
                                            }}
                                            label="Whitepapers"
                                        />

                                        <FormCheckbox
                                            id="checkbox2"
                                            checked={customerChecks}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setCustomerChecks(checked ?? false);
                                            }}
                                            label="Customer Stories"
                                        />

                                        <FormCheckbox
                                            id="checkbox5"
                                            checked={productUpdateChecks}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setProductUpdateChecks(checked ?? false);
                                            }}
                                            label="Product Update"
                                        />

                                        <FormCheckbox
                                            id="checkbox3"
                                            checked={eventsCheck}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setEventsCheck(checked ?? false);
                                            }}
                                            label="Events"
                                        />
                                        <FormCheckbox
                                            id="checkbox4"
                                            checked={mediaChecks}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setMediaChecks(checked ?? false);
                                            }}
                                            label="Media"
                                        />

                                        <FormCheckbox
                                            id="checkbox6"
                                            checked={podcastsChecks}
                                            onChange={(checked) => {
                                                console.log(checked, "Checked..");
                                                setPodcastsChecks(checked ?? false);
                                            }}
                                            label="Podcasts"
                                        />

                                    </div>

                                </div>
                            </div>
                            <div className={"right-block"}>
                                <div className={'content'}>
                                    <div className={'d-flex'}>
                                        {filteredData.length > 0 ?
                                            (filteredData.slice(0, visibleCount).map((__data, index) => {
                                            let data = __data.node
                                            return (
                                                <div className={'inner-block'} key={index}>
                                                    <Link href={data.uri} itemProp="url">
                                                        <div className={'image-wrapper'}>
                                                            <img src={data.featuredImage.node.sourceUrl}
                                                                 alt={data.title} width={"100%"} height={"93%"}/>
                                                        </div>
                                                    </Link>
                                                    <div className={`category ${data.categories?.edges[0]?.node?.slug}`}>{data.categories?.edges[0]?.node?.name}</div>
                                                    <Link href={data.uri} itemProp="url"><h3
                                                        className={'font-inter'}>{data.title}</h3></Link>
                                                    <Link href={data.uri} itemProp="url" className={"read-more"}>Read More</Link>
                                                </div>
                                            )
                                        })) : <div className="no-results">
                                            <NoData/>
                                            <p> Oops! It’s empty like space. <br/>
                                                No data available</p>
                                        </div>}
                                    </div>
                                    {visibleCount < filteredData.length && (
                                        <div className={"button-shadow-view"}> <button className="view-more-btn" onClick={handleViewMore}>
                                            View More
                                        </button></div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className={"event-calender"}>
                    <div className={"container"}>
                        <div className={"top-heading"}>
                            <h2>Event Calendar</h2>
                            <Link
                                href={"/events"}
                                className={"read-more"}
                            >
                                {" "}
                                View All{" "}
                            </Link>
                        </div>

                        <div className={"event-list"}>
                            {
                                eventCalendar.map((event, index) => {
                                    return <div className={"d-flex"} key={index}>
                                        <div className={"event-left"}>
                                            <div className={`category product-update`}>Event</div>
                                            <h3>{event.node.title}</h3>
                                            <p>{event.node.location}</p>
                                        </div>
                                        <div className={"event-right"}>
                                            <div className={"btn-flex"}>
                                                <div className={"event-date"}>
                                                    <p>{event.node.date}</p>
                                                </div>
                                                <div className={"event-button"}>
                                                    <Link href={event.node.uri} target={"_blank"} className={"ahref-btn primary"}>Read More</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>

                    </div>
                </section>

                <div className={"subscribe-cta-blog"}>
                    <div className={"container"}>
                        <SubscribeCtaBlog />
                    </div>
                </div>

                <ProductUpdates productUpdates={productUpdates} />

                <CallToActionBlogBottom img={"/images/resources/middleware-resource-team.png"}/>
            </div>
        </Layout>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    const allWhitepaper = await getAllWhitepaper()
    const allProductUpdates = await getProductUpdatesPosts()
    const allPodcasts = await getAllPodcast()
    const allWebinars = await getAllWebinars()


    return {
        props: {
            ...translations,
            allWhitepaper,
            preview: false,
            allProductUpdates: allProductUpdates,
            allPodcasts: allPodcasts,
            allWebinars,
            pageTitle: 'Observability Resources | Middleware',
            ogImage: "/images/resources/resources-page-og.png",
            metaTitle: 'Observability Resources | Middleware',
            metaDesc: 'Browse Middleware\'s resource library for in-depth guides, whitepapers, and webinars to enhance your skills and stay ahead.',
            description: 'Browse Middleware\'s resource library for in-depth guides, whitepapers, and webinars to enhance your skills and stay ahead.',
            uri: '/resources/',
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
    }
}